import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager } from 'ng-jhipster';
import { UnavailableDate } from './unavailable-date.model';
import { UnavailableDateService } from './unavailable-date.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'jhi-unavailable-date-detail',
    templateUrl: './unavailable-date-detail.component.html'
})
export class UnavailableDateDetailComponent implements OnInit, OnDestroy {

    unavailableDate: UnavailableDate;
    private subscription: any;
    private unavailableDateSubscription: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private unavailableDateService: UnavailableDateService,
        private route: ActivatedRoute,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['unavailableDate']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.registerChangeInUnavailableDate();
    }

    load(id) {
        this.unavailableDateService.find(id).subscribe(unavailableDate => {
            this.unavailableDate = unavailableDate;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.unavailableDateSubscription.unsubscribe();
    }

    registerChangeInUnavailableDate() {
        this.unavailableDateSubscription = this.eventManager
        .subscribe('unavailableDateListModification', (response) => this.load(this.unavailableDate.id));
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date-detail.component.ts